var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTrash = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 52,
  height: 66,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.593.968 16.39 4.17H.375v6.406h3.203v48.046c0 1.673.613 3.378 1.82 4.586 1.208 1.207 2.914 1.82 4.586 1.82h32.031c1.673 0 3.378-.613 4.586-1.82 1.207-1.208 1.82-2.913 1.82-4.586V10.577h3.203V4.171H35.61L32.406.968H19.593Zm-9.609 9.609h32.031v48.046H9.985V10.577Zm6.406 6.406v35.234h6.407V16.983H16.39Zm12.813 0v35.234h6.406V16.983h-6.406Z",
  fill: "#D65F5C"
})));
export default SvgTrash;